import React, { useState } from 'react';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';

import {ReleaseNotesContent} from "./ReleaseNotesContent";

export default function ReleaseNotesDialogue({open, onClose, selectorContractGridAPI
                                               }) {

    const handleCloseInfo = () => {
        onClose(true);
    };

    const info = ReleaseNotesContent(selectorContractGridAPI);

    return (
        <>

            <Dialog
                open={open}
                onClose={onClose}
            >

                <DialogTitle>
                    {info.title}
                </DialogTitle>

                <DialogContent>
                    {info.content}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseInfo}>
                        Close
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    );
}